import React, { Fragment } from 'react';
import {
    Row, Button, FormGroup, Label, Input, Modal,
    ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import usePProduccion from '../../hooks/usePProduccion';


function AlmacenProduccion() {
    //Declaración de variables        
    const { verpproducciones, pproducciones, cargando1, pageRange, searchBy, reciba, currentPage, recordPerPage, totalRecords,
        rPANOFIFO, search, modal3, noFIFOUsuarios, noFIFOUsuarios2, onSearchFecha, fetchReciba, toggle3, onSearch,
        buscarpor, setSearch, onChangescheckVUAP, obtenerUltimaUbicaciont, handlePageChange, cancelarRANOFIFO,
        setComentariosNoFIFO, setUsuarioAutNoFIFO, setUsuarioAutNoFIFO2, aceptarRANOFIFO } = usePProduccion();

    return (
        <>

            {(pproducciones === true || verpproducciones === true) && (
                <>
                    {cargando1 === true && (
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                        </Row>
                    )}
                    <Row>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px" >
                            <h5 className=" floatleft">Agregar plan de producción desde almacén</h5>
                            {/*<button className="cbutton btn-info floatright ml-2 mr-3" title="Finalizar agregado desde almacén" onClick={() => { toggle1('4'); }}> Finalizar agregado</button>*/}
                        </div>
                    </Row>
                    <div class="col-lg-7 col-md-9 col-sm-12 col-xs-12 text-left  margintop20px" >
                        <Label><h5>Busqueda por: </h5></Label>
                        <select name="recibabusqueda" className="ml-2" onChange={buscarpor}>
                            <option value="cliente" >Cliente</option>
                            <option value="paking">Packing</option>
                            <option value="numero de parte">Número de parte</option>
                            <option value="lote">Lote</option>
                            <option value="fecha">Fecha</option>
                            <option value="serial" >Serial</option>
                            <option value="serial BTI" >Serial BTI</option>
                            <option value="id de reciba" >ID de Reciba</option>
                        </select>
                        <Input
                            type={searchBy !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + searchBy}
                            onChange={searchBy !== "fecha" ? (e) => setSearch(e.target.value) : onSearchFecha}
                            onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                            value={search}
                        />
                    </div>
                    <Row>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-left  margintop10px">
                            <Label className="floatleft"><input type="checkbox" name="VUAP" onChange={onChangescheckVUAP} className='ml-2' />Vista del último al primero</Label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center  margintop10px">
                            <Label className="floatleft ml-2 "> Días en planta: </Label>
                            <Label className="floatleft ml-2 bcolorlb">{"de 3 a 7"}</Label>
                            <Label className="floatleft ml-2 bcolorbb ">{"de 8 a 15"}</Label>
                            <Label className="floatleft ml-2 bcolorr"> {"más de 15"}</Label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12   margintop10px">
                            <button className="cbutton btn-dark floatright mr-3" title="Recargar página" onClick={() => { fetchReciba(); }}><IoIcons.IoMdRefresh /> Recargar </button>
                        </div>
                    </Row>
                    <div className={reciba.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                        " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                        <Table className="mb-2 scroll ">
                            <Thead class="thead-secondary">
                                <Tr>
                                    <Th >ID</Th>
                                    <Th >Cliente</Th>
                                    <Th >Número de parte</Th>
                                    <Th >Días en planta</Th>
                                    <Th>Descripción</Th>
                                    <Th>Packing </Th>
                                    <Th>Lote</Th>
                                    <Th>Proceso</Th>
                                    <Th >Serial </Th>
                                    <Th >Serial BTI</Th>
                                    <Th>Cantidad</Th>
                                    <Th >Última ubicación</Th>
                                    {/*<Th className="width30px" > Producción </Th>*/}
                                </Tr>
                            </Thead>
                            <Tbody>
                                {reciba.map((reciba, i) => (
                                    //reciba.cantidadPlaneada < reciba.cantidadRecibida && (
                                    <Tr className={(reciba.FEPlanta >= 3 && reciba.FEPlanta <= 7) ? "bcolorlb" :
                                        (reciba.FEPlanta >= 8 && reciba.FEPlanta <= 15) ? "bcolorbb" :
                                            (reciba.FEPlanta > 15) ? "bcolorr" :
                                                i % 2 !== 0 ? "table-active" : ""}>
                                        <Td>{reciba.numero}</Td>
                                        <Td>{reciba.cliente}</Td>
                                        <Td className="margintopmobil20px">{reciba.numerodeParte}</Td>
                                        <Td className="margintopmobil20px">{reciba.FEPlanta}</Td>
                                        <Td className="margintopmobil20px">{reciba.descripcion}</Td>
                                        <Td className="margintopmobil20px">{reciba.packing}</Td>
                                        <Td className="margintopmobil20px">{reciba.lote}</Td>
                                        <Td className="margintopmobil20px">
                                            <Label>{(reciba.Ecoat === true || (!reciba.Ecoat && reciba.precioUnitario)) ? "Ecoat" : ""}</Label>
                                            <br></br>
                                            <Label className="margintop20px">{reciba.Pcoat === true ? " Powder coat" : ""}</Label>
                                            {/*<Label className="margintop20px">{reciba.Platinado === true ? " Platinado" : ""}</Label>*/}
                                        </Td>
                                        <Td className="margintopmobil40px">{reciba.serial} </Td>
                                        <Td className="margintopmobil40px">{reciba.serialRecibaBTI} </Td>
                                        <Td className="margintopmobil20px">{reciba.cantidadRecibida - reciba.cantidadPlaneada}</Td>
                                        <Td className="margintopmobil20px">{obtenerUltimaUbicaciont(reciba.ultimaUbicacion)}</Td>
                                        {/*<Td className="margintopmobil40px">
                                                                <button class="btn-success cbutton mt-1 ml-1" onClick={() => clicAdddeAlmacen(reciba)} title="Nueva planeación" disabled={bloquearAgregado}> <IoIcons.IoMdAdd /> </button>
                                                            </Td>*/}
                                    </Tr>
                                    // )
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                    <div className="mt-3 mb-3">
                        Página {currentPage}, mostrando del {(recordPerPage * currentPage - recordPerPage) + 1}  al {totalRecords < recordPerPage * currentPage ? totalRecords : recordPerPage * currentPage} de {totalRecords} registros
                    </div>
                    <Row>
                        <div className="col-lg-12 col-md-12 col-sm-12  " >
                            <div className="floatcenter">
                                <Pagination
                                    itemClass="page-item" // add it for bootstrap 4
                                    linkClass="page-link" // add it for bootstrap 4                                    
                                    activePage={currentPage}
                                    itemsCountPerPage={recordPerPage}
                                    totalItemsCount={totalRecords}
                                    pageRangeDisplayed={pageRange}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </div>
                    </Row>
                    <Modal isOpen={modal3} toggle={toggle3}>
                        {rPANOFIFO.solNoFIFO && ( //Si ya existe una solicitud de NoFIFO, se pregunta si se quiere cancelar
                            <>
                                {rPANOFIFO.autNoFIFO === "Rechazada" && ( //Si la solicitud se ha resuelto como Rechazada
                                    <>
                                        <ModalHeader toggle={toggle3}>Solicitud para no usar el FIFO  Rechazada</ModalHeader>
                                        <ModalBody>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <FormGroup>
                                                    <Label className="floatleft ">La solicitud para la no aplicación del FIFO para el registro seleccionado ha sido Rechazada por los siguientes motivos:</Label>
                                                    <Input name="comentarios" maxLength={600} type="textarea" rows="4" readOnly="true" value={rPANOFIFO.autPNoFIFOComentTIOA} />
                                                </FormGroup>
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="danger" onClick={toggle3}>Salir</Button>
                                        </ModalFooter>
                                    </>
                                )}{!rPANOFIFO.autNoFIFO && ( //Si ya existe una solicitud de NoFIFO que no ha sido autorizada, se pregunta si se quiere cancelar
                                    <>
                                        <ModalHeader toggle={toggle3}>Solicitud para no usar el FIFO  ya registrada</ModalHeader>
                                        {rPANOFIFO.solNoFIFOModulo === "Planeación" && (<>
                                            <ModalBody>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <p>Ya existe una solicitud para la no aplicación del FIFO para el
                                                        material seleccionado por el área de Planeación, para mayor
                                                        información comunicarse con dicha área.</p>
                                                </div>
                                            </ModalBody>
                                        </>)}
                                        {rPANOFIFO.solNoFIFOModulo === "Producción" && (<>
                                            <ModalBody>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <p>Ya existe una solicitud para la no aplicación del FIFO para el material seleccionado, ¿Deseas cancelar dicha solicitud?</p>
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <FormGroup>
                                                        <Label className="floatleft ">Motivos para cancelar la solicitud NoFIFO*:</Label>
                                                        <Input name="comentarios" maxLength={600} type="textarea" rows="4" autoFocus onChange={(e) => setComentariosNoFIFO(e.target.value)} />
                                                    </FormGroup>
                                                </div>
                                            </ModalBody>
                                        </>)}
                                        <ModalFooter>
                                            {rPANOFIFO.solNoFIFOModulo === "Producción" && (
                                                <Button color="primary" onClick={cancelarRANOFIFO}>Cancelar solicitud</Button>
                                            )}
                                            <Button color="danger" onClick={toggle3}>Salir</Button>
                                        </ModalFooter>

                                    </>
                                )}
                            </>
                        )}
                        {!rPANOFIFO.solNoFIFO && ( //Si no existe una solicitud para autorizar el NoFIFO, se permite registrarla
                            <>
                                <ModalHeader toggle={toggle3}>Solicitar autorización para no usar el FIFO </ModalHeader>
                                <ModalBody>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <p>Hay un registro con fecha más antigua de reciba en almacén. Se requiere autorización para continuar con el agregado de este material al plan de producción.</p>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <FormGroup>
                                            <Label className="floatleft ">Motivos para no usar el FIFO*:</Label>
                                            <Input name="comentarios" maxLength={600} type="textarea" rows="4" autoFocus onChange={(e) => setComentariosNoFIFO(e.target.value)} />
                                        </FormGroup>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left " >
                                        <Label>Solicitar autorización al área de Planeación:</Label>
                                        <select name="NoFIFOSolicitudAUsuario1" className="floatleft custom-select mb-2" onChange={(e) => setUsuarioAutNoFIFO(e.target.value)} >
                                            <option value="" >Elige una opción</option>
                                            {noFIFOUsuarios.map(usuarios => (
                                                <option value={usuarios.nombreCompleto} >{usuarios.nombreCompleto}</option>
                                            ))}
                                        </select>

                                        <Label>Solicitar autorización al área de calidad:</Label>
                                        <select name="NoFIFOSolicitudAUsuario2" className="floatleft custom-select" onChange={(e) => setUsuarioAutNoFIFO2(e.target.value)} >
                                            <option value="" >Elige una opción</option>
                                            {noFIFOUsuarios2.map(usuarios => (
                                                <option value={usuarios.nombreCompleto} >{usuarios.nombreCompleto}</option>
                                            ))}
                                        </select>

                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={aceptarRANOFIFO}>Aceptar</Button>{' '}
                                    <Button color="danger" onClick={toggle3}>Salir</Button>
                                </ModalFooter>
                            </>
                        )}
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(rPANOFIFO)}</div>*/}
                    </Modal>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(reciba)}</div>*/}

                </>
            )
            }
        </>
    )
};



export default AlmacenProduccion;